import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';
import appConfig from "../../app.config";
import store from '../state/store';
//import SubscriptionService from "../services/SubscriptionService";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Correction du routeur
router.beforeEach(async (routeTo, routeFrom, next) => {
  // Instance du service
 // let subscriptionService = new SubscriptionService();
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  /*// 1. Gérer la redirection des utilisateurs sans abonnement
  // On s'assure que l'utilisateur n'est pas déjà sur la page "sans abonnement" pour éviter une boucle de redirection
  if (routeTo.path !== '/no-subscription' && authRequired) {
    let isSubscribed = await subscriptionService.checkSubscription();
    if (!isSubscribed) {
      return next("/no-subscription"); // Un seul appel à next()
    }
  }*/

  // 2. Gérer l'authentification
  if (!authRequired) {
    return next();
  }

  if (store.state.currentUser === null) {
    // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
    return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  } else {
    // Si l'utilisateur est connecté et activé, continuer la navigation
    if (store.state.currentUser.enabled === true) {
      return next();
    } else {
      return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  }
});

// Supprimer la deuxième garde de navigation si sa logique est déjà gérée dans la première
router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/register', '/forgot-password', '/landing', '/logout'];
  // Utilisation de .some ou une regex pour les routes dynamiques comme register/step2
  const isPublicPage = publicPages.includes(routeTo.path) || routeTo.path.startsWith('/register/step2');
  const loggedUser = localStorage.getItem('currentUser');
  const user = store.state.currentUser;

  // 1. Redirection si non connecté
  if (!isPublicPage && !loggedUser) {
    return next('/login');
  }

  // 2. Si on est sur une page publique ou qu'on vient de se connecter
  if (isPublicPage) {
    return next();
  }

  // 3. Logique spécifique pour le rôle POS
  // Si l'utilisateur est POS et qu'il essaie d'aller ailleurs que sur sa page dédiée
  if (user && user.type && user.type.nom === 'POS') {
    if (routeTo.path !== '/ventes/gui_pos') {
      return next('/ventes/gui_pos');
    } else {
      return next(); // Il est déjà sur la bonne page, on le laisse passer
    }
  }

  // 4. Vérification des permissions pour les autres rôles (Admin, etc.)
  if (routeTo.meta.authRequired === true) {
    const isSuperAdmin = user.type.nom === 'Super Admin';
    const hasPermission = user.type.permissions && user.type.permissions.some(p => p === routeTo.meta.key);

    if (isSuperAdmin || hasPermission) {
      return next();
    } else {
      // Si aucune permission, redirection vers Unauthorized
      return next({ name: 'Unauthorized' });
    }
  }

  next();
});
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  next();
});

export default router;
